import React from 'react'

import { useIntersected } from '@/shared/hooks/intersected'

// styles
import { cssClass } from '@/shared/utils/styles'
import { opacity0, animateContainerVariations } from './styles'

interface Props {
  refEl?: React.RefObject<HTMLDivElement>
  children?: React.ReactNode
  className?: string[]
  beforeAnimationClassName?: string[]
  duration?: number
  delay?: number
  delayAfter?: number
  threshold?: number
  type: keyof typeof animateContainerVariations
  setOpacityNone?: boolean
  manualActive?: boolean
  active?: boolean
  getRef?: (refUsed: React.RefObject<HTMLDivElement>) => void
}

export const AnimateContainer: React.FC<Props> = ({
  refEl,
  children,
  className = [''],
  duration = 0.5,
  delay = 0,
  delayAfter = 0,
  threshold = 0.5,
  beforeAnimationClassName = [''],
  type,
  setOpacityNone = false,
  manualActive = false,
  active = false,
  getRef,
}) => {
  const thisRef = React.useRef<HTMLDivElement>(null)
  const [isIntersected] = useIntersected({ ref: refEl || thisRef, threshold })
  const [showAnimation, setShowAnimation] = React.useState(false)

  React.useEffect(() => {
    if (isIntersected && !manualActive) {
      setTimeout(() => {
        setShowAnimation(true)
      }, delay)
    }
  }, [delay, isIntersected, manualActive])

  React.useEffect(() => {
    if (manualActive) {
      if (active) {
        setTimeout(() => setShowAnimation(true), delay)
      } else {
        setTimeout(() => setShowAnimation(false), delayAfter)
      }
    }
  }, [active, manualActive, delay, delayAfter])

  React.useEffect(() => {
    if (getRef) {
      getRef(thisRef)
    }
  }, [thisRef, getRef])

  const opacityNone = setOpacityNone ? opacity0 : ''
  const animateClass = showAnimation
    ? animateContainerVariations[type]
    : cssClass([...beforeAnimationClassName, opacityNone])

  return (
    <div
      style={{ animationDuration: duration + 's' }}
      ref={thisRef}
      className={cssClass([...className, animateClass])}
    >
      {children}
    </div>
  )
}
